<template>
  <div class="m-componets m-pirnt-service">
    <div class="tool-box">
      <div class="title ft-black">最新版本打印服务</div>
      <div class="link-line">
        <div class="btn-link ft-blue pointer" type="text" @click.stop="downloadPrintTool(3.5)"><i class="el-icon-download"></i>framework3.5</div>
        <div class="text ft-org">优先选择</div>
      </div>
      <div class="link-line">
        <div class="btn-link ft-blue pointer" type="text" @click.stop="downloadPrintTool(4.0)"><i class="el-icon-download"></i>framework4.0</div>
        <div class="text ft-grey">如遇安装失败请下载此版本</div>
      </div>
      <div class="link-help">
        <i class="el-icon-question" style="color: #D0D4DC"></i>
        <span>如果有疑问请点击查看</span>
        <span class="btn-link ft-blue pointer" @click="toHelpDetail()">《打印服务安装与使用说明》</span>
      </div>
    </div>
    <div class="form-box">
      <div class="f_item">
        <span class="f_label">测试机构</span>
        <div class="f_content">
          <el-select size="small" v-model="orgCode" placeholder="请选择" popper-class="f_el-select-dropdown" filterable style="width: 240px">
            <el-option
              v-for="item in orgOptions"
              :key="item.stCode"
              :label="item.label"
              :value="item.stCode">
            </el-option>
          </el-select>
          <div class="btns-line">
            <el-button class="btn-test" size="small" :loading="testLoading && printType === 1" @click="printTest(1)">打印测试</el-button>
            <el-button class="btn-test" size="small" :loading="testLoading && printType === 2" @click="printTest(2)">语音播报测试</el-button>
          </div>
          <div class="logs-line">
            <div class="log-item" v-for="(item, index) in printLogs" :key="index">
              <div class="log-time ft-grey">
                <i class="dot"></i>{{ item.printTime }}
              </div>
              <div class="log-info">
                <template v-if="item.type === 1">
                  <div class="log-text ft-black">已发送测试打印小票</div>
                  <div class="log-desc">如未打印，请检查本地打印服务是否有效</div>
                </template>
                <template v-if="item.type === 2">
                  <div class="log-text ft-black">已发送测试语音</div>
                  <div class="log-desc">如未播放语音，请检查本地音频服务是否有效</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import printService from '@/module/apis/printService'
import MC from '@/module/MC'
import dayjs from 'dayjs'

export default {
  name: 'mPrintService',
  data () {
    return {
      downloading: false,
      testLoading: false,
      orgOptions: [],
      orgCode: '',
      printType: 0,
      printLogs: []
    }
  },
  created () {
    this.getOrgOptions()
  },
  methods: {
    downloadPrintTool (version) {
      if (this.downloading) return
      this.downloading = true
      printService.getVersionInfLately().then(res => {
        this.downloading = false
        const versionUrl = version === 4.0 ? res.exeFileForFourZero : res.exeFileForThreeFive
        const url = this.handleHttpUrl(versionUrl)
        window.location.href = url
      }).catch(err => {
        this.downloading = false
        this.$message.error(err.msg || '下载失败，请稍后重试')
      })
    },
    toHelpDetail () {
      window.open('https://mzhudhby0v.feishu.cn/docs/doccnXz5EDHB4bpDq8gCVwqaeud', '_oms_print_help')
    },
    handleHttpUrl (url) {
      if (url && url !== '') {
        if (location.protocol === 'https:') { // 处理https 环境文件不安全问题
          let index = url.indexOf('http:')
          if (index > -1) {
            url = url.replace(/http:/, 'https:')
          }
        }
      }
      console.log('url ===', url)
      return url
    },
    getOrgOptions () {
      const params = {
        merCode: MC.config.merCode,
        userId: MC.config.userInfo.id,
        onlineStoreStatus: 1, // 是否有线上门店 int(1.是 0.否)
        onlineStatus: null, // 微商城是否上线
        status: 1,
        pageSize: 20000,
        currentPage: 1
      }
      printService.getUserOfflineStores(params).then(res => {
        this.orgOptions = (res.data || []).map(v => {
          v['label'] = `${v.stName}(${v.stCode})`
          return v
        })
        if (this.orgOptions.lenght === 1) {
          this.orgCode = this.orgOptions[0].stCode
        }
      }).catch(err => {
        this.$message.error(err.msg || '获取数据失败')
      })
    },
    async printTest (type) {
      if (this.orgCode === '') {
        this.$message.warning('请先选择测试机构')
        return
      }
      if (this.testLoading) {
        this.$message('正有服务在测试，请稍后')
        return
      }
      this.testLoading = true
      this.printType = type
      type === 1 ? await this.printAction() : await this.voiceAction()
      // 更新记录
      let printTime = dayjs(new Date()).format('HH:mm:ss')
      const record = { type, printTime }
      this.updatePrintLogs(record)
    },
    updatePrintLogs (record) {
      const { printLogs } = this
      console.log('printLogs===', printLogs)
      if (printLogs.length >= 1) {
        const index = printLogs.findIndex(v => v.type === record.type)
        if (index > -1) {
          printLogs.splice(index, 1)
        }
      }
      printLogs.push(record)
    },
    printAction () {
      const params = {
        organizationCode: this.orgCode
      }
      printService.testPrintAction(params).then(res => {
        setTimeout(_ => {
          this.testLoading = false
        }, 3000)
        this.$message.success('测试打印已发送成功，如未打印，请检查本地打印服务是否有效！')
      }).catch(err => {
        setTimeout(_ => {
          this.testLoading = false
        }, 1000)
        this.$message.error(err.msg || '')
      })
    },
    voiceAction () {
      const params = {
        onlineStoreCode: '',
        organizationCode: this.orgCode,
        soundType: 1,
        newOrder: 1
      }
      printService.testVoiceAction(params).then(res => {
        setTimeout(_ => {
          this.testLoading = false
        }, 4000)
        this.$message.success('测试语音已发送成功，如未播放语音，请检查本地音频服务是否有效！')
      }).catch(err => {
        setTimeout(_ => {
          this.testLoading = false
        }, 1000)
        this.$message.error(err.msg || '')
      })
    }
  }
}
</script>
<style lang="scss" rel="stylesheet/scss">
  .tool-box {
    background: #F9F9FA;
    padding: 12px 20px;
    .title {
      line-height: 20px;
      color: #4A4A4A;
    }
    .link-line {
      display: flex;
      align-items: center;
      line-height: 28px;
      .btn-link{
        display: flex;
        flex: 0 0 auto;
        font-size: 14px;
        margin: 0 10px 0 0;
        i {
          margin: 8px 4px 0 0;
        }
      }
      .text{
        flex: 0 0 aut0;
      }
    }
    .link-help {
      margin-top: 12px;
      line-height: 1.5;
    }
  }
  .form-box {
    padding: 12px 20px;
    .f_item {
      display: flex;
      .f_label {
        flex: 0 0 atuo;
        line-height: 32px;
        margin-right: 12px;
      }
      .f_content {
        flex: 1;
      }
      .btns-line{
        margin-top: 20px;
      }
      .logs-line {
        margin-top: 20px;
        .log-item {
          margin-top: 20px;
          display: flex;
          font-size: 12px;
          line-height: 18px;
        }
        .log-time {
          display: flex;
          flex: 0 0 auto;
          height: 100%;
          margin-right: 12px;
          .dot {
            margin: 6px 8px 0 0;
            display: block;
            background: #C4C4C4;
            border-radius: 6px;
            width: 6px;
            height: 6px;
          }
        }
        .log-text {
          margin-bottom: 5px;
        }
        .log-desc {
          color: #666;
        }
      }
    }
  }
  .ft-org {
    color: #FA8919;
  }
  .ft-blue {
    color: #4F88FF;
  }
  .ft-grey {
    color: #909399;
  }
  .ft-black {
    color: #303030;
  }
  .pointer {
    cursor: pointer;
  }
</style>
<style lang="scss">
  .m-pirnt-service {
    .btn-test {
      border: 1px solid #4F88FF;
      color: #4F88FF;
    }
  }
  .f_el-select-dropdown{
    .el-select-dropdown__item {
      max-width: 400px;
      overflow: hidden;
    }
  } 
</style>


// WEBPACK FOOTER //
// src/js/module/layout/_source/printService.vue